// Minimal client-side sanitizers and helpers
// These are not replacements for server-side validation and HTTP headers, but
// they help reduce common client-side risks.

export const escapeHtml = (unsafe) => {
  if (unsafe == null) return '';
  return String(unsafe)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

// Only allow simple, relative paths made of alphanumerics, hyphens, underscores and slashes
export const sanitizePathParam = (p) => {
  if (!p) return '';
  const cleaned = p.replace(/^\/*/, '').replace(/\/*$/, '');
  // reduce to safe chars only
  if (!/^[-_\w\/]+$/.test(cleaned)) return '';
  return cleaned;
};

// Safe URL check for images and external links (simple allowlist by host)
export const isSafeUrl = (url, allowedHosts = []) => {
  try {
    const u = new URL(url, window.location.origin);
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return false;
    if (allowedHosts.length === 0) return true; // allow all by default
    return allowedHosts.some(host => u.host.endsWith(host));
  } catch (e) {
    return false;
  }
};

export default { escapeHtml, sanitizePathParam, isSafeUrl };

// CommonJS fallback for small local test scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { escapeHtml, sanitizePathParam, isSafeUrl };
}
